import { TermOption } from '@/app/domain/webservice-dto';

export const toastDuration = 5000;
export const snackbarDuration = 15000;
export const deductibles: TermOption[] = [
    { value: '1\'000', identifier: '1000', sequenceNumber: 1},
    { value: '2\'000', identifier: '2000', sequenceNumber: 2},
    { value: '5\'000', identifier: '5000', sequenceNumber: 3},
];
